import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueCropper from "vue-cropperjs";
export default {
  name: "Cropper",
  components: {
    VueCropper: VueCropper
  },
  props: {
    imageBase64: {
      type: String,
      required: true
    },
    cropPopupVisible: {
      type: Boolean,
      required: true
    },
    aspectRatio: {
      type: Number,
      required: true,
      default: 0
    },
    fileType: {
      type: String,
      required: true
    }
  },
  methods: {
    cropImage: function cropImage() {
      var _this = this;

      var canvas = this.$refs.cropper.cropper.getCroppedCanvas();
      canvas.toBlob(function (blob) {
        _this.$emit("cropImage", blob);
      }, this.fileType, 0.3);
    },
    rotate: function rotate(degree) {
      this.$refs.cropper.cropper.rotate(degree);
    }
  }
};